<template>
  <div class="">
    <div class="w-[100vw] bg-black flex justify-between items-center px-5">
      <topbar class="bg-black text-white text-sm w-2/3 px-10 py-8"></topbar>
      <div>
        <button
          @click="Logout()"
          class="bg-red-400 hover:bg-red-500 px-4 py-3 rounded-lg text-white font-bold"
        >
          Logout
        </button>
      </div>
    </div>
    <!-- table to contain the information -->
    <div class="bg-foreGroundColor p-5 mt-5 rounded-lg">
      <div class="flex justify-between items-center">
        <p class="font-semibold text-[18px]">Parcel Information</p>
      </div>

      <div
        class="relative overflow-x-auto border-2 shadow-md sm:rounded-lg mt-5"
      >
        <table
          class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
        >
          <thead
            class="text-xs text-center text-gray-700 bg-tableHeaderColor border-b-2"
          >
            <tr>
              <th scope="col" class="px-6 py-3">HAWB</th>
              <th scope="col" class="px-6 py-3">Items</th>
              <th scope="col" class="px-6 py-3">Parcel Date</th>
              <th scope="col" class="px-6 py-3">Hub</th>
              <th scope="col" class="px-6 py-3">Description</th>
              <th scope="col" class="px-6 py-3">D.Warehouse</th>
              <th scope="col" class="px-6 py-3">Origin Tracking Number</th>
              <th scope="col" class="px-6 py-3">Goods Value</th>
              <th scope="col" class="px-6 py-3">Chargable Wt.</th>
              <th scope="col" class="px-6 py-3">Notes</th>
              <th scope="col" class="px-6 py-3">Status</th>
              <th scope="col" class="px-6 py-3">Images</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="data in allparcel"
              :key="data.id"
              class="text-[12px] text-center odd:bg-gray-50 even:bg-gray-100 border-b dark:border-gray-300 text-black"
            >
              <td class="px-6 py-2">
                <button
                  title="Parcel Status Timeline"
                  @click="showImages(data.id)"
                >
                  {{ data?.hawb[0]?.uniqueId }}
                </button>
              </td>
              <td class="px-6 py-2">{{ data.quantity }}</td>
              <td class="px-6 py-2">{{ data.dateReceived }}</td>
              <td class="px-6 py-2">{{ data.hubWarehouse }}</td>
              <td class="px-6 py-2">{{ data.description }}</td>
              <td class="px-6 py-2">{{ data.destinationWarehouse }}</td>
              <td class="px-6 py-2">{{ data.originTrackingNumber }}</td>
              <td class="px-6 py-2">{{ data.value }}</td>
              <td class="px-6 py-2">{{ data.volumectricWeight }}</td>
              <td class="px-6 py-2">{{ data.note }}</td>
              <td class="px-6 py-2">
                {{ data.completion_status ? "ready to collect" : "not ready" }}
              </td>
              <td class="px-6 py-2">
                <button
                  @click="showImages(data.id)"
                  class="bg-primaryButtonColor hover:bg-orange-500 text-white px-3 py-2 rounded-md"
                >
                  Click to Preview Image
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- pop up for the image -->
    <div v-if="showImagePopUp">
      <div class="popupContainer">
        <div class="bg-white ml-20 z-30 w-[80rem] rounded-md">
          <div class="px-6 py-6 rounded-b-lg">
            <div class="grid grid-cols-3">
              <template v-for="image in selectedImages" :key="image.id">
                <div>
                  <img
                    :src="image.picture1"
                    alt="Image"
                    class="max-w-full max-h-full"
                  />
                </div>
                <div>
                  <img
                    :src="image.picture2"
                    alt="Image"
                    class="max-w-full max-h-full"
                  />
                </div>
                <div>
                  <img
                    :src="image.picture3"
                    alt="Image"
                    class="max-w-full max-h-full"
                  />
                </div>
                <div>
                  <img
                    :src="image.picture4"
                    alt="Image"
                    class="max-w-full max-h-full"
                  />
                </div>
                <div>
                  <img
                    :src="image.picture5"
                    alt="Image"
                    class="max-w-full max-h-full"
                  />
                </div>
              </template>
            </div>
            <button
              class="py-2 px-4 bg-primaryButtonColor rounded-lg text-white"
              @click="showImagePopUp = !showImagePopUp"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>

<script setup>
import api from "../../../boot/axios.js";
import sidebar from "@/components/sidebar/Sidebar";
import topbar from "@/components/CustomerTopBar/CustomerTopNavBar.vue";
import { sidebarWidth } from "@/components/sidebar/state";
import {
  ref,
  onMounted,
  onBeforeMount,
  getCurrentInstance,
  computed,
} from "vue";

const allparcel = ref([]);
const customeremail = ref(localStorage.getItem("email"));
const customerId = ref(null);

//------**--------
const showImagePopUp = ref(false);
const selectedId = ref(null);
const selectedImages = ref([]);
//------**--------
const perPage = ref(10);
const currentPage = ref(1);
const searchQuery = ref("");

const instance = getCurrentInstance();

// Api calling

const getallApis = async () => {
  // calling cutomer filterd parcels
  await api.get(`api/customer/?email=${customeremail.value}`).then((res) => {
    customerId.value = res.data[0].id;
  });
  await api.get(`api/parcel/?cusId=${customerId.value}`).then((res) => {
    console.log(res.data, "all-parcel-info");
    allparcel.value = res.data;
  });
};

// methods calling
const showImages = async (id) => {
  selectedId.value = id;
  // calling api based on the parcel id
  try {
    const response = await api.get(`api/picture_parcel/?parcelId=${id}`);
    selectedImages.value = response.data;
    showImagePopUp.value = true;
  } catch (error) {
    console.error("Error fetching images:", error);
  }
};

const Logout = () => {
  localStorage.clear();
  instance.proxy.$router.push({ name: "home" });
};

onMounted(() => {
  getallApis();
});
</script>
<style scoped>
.popupContainer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 10;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.491);
}
</style>
